import type { Helix2000Character } from '../../../shared/CharacterTypes';
import { resolvePlayerEquipmentVisuals } from '../../../shared/equipmentVisuals';
import { hasLiveVitals } from '../../systems/player/livePlayerVitals';

const EMPTY = resolvePlayerEquipmentVisuals({});
function plain(value: any): any {
  const source = typeof value?.toJSON === 'function' ? value.toJSON() : value;
  return source ? JSON.parse(JSON.stringify(source)) : undefined;
}

/** Materialize before memo comparison; schema/proxy identity is not a change signal. */
export function playerInfoSnapshot(player: Helix2000Character) {
  const appearance = plain(player.appearance);
  const equipmentVisuals = plain(player.equipmentVisuals) ?? EMPTY;
  const statPoints = player.statPoints ?? 0;
  const skillPoints = player.skillPoints ?? 0;
  const snapshot = { ...player, name: player.name, class: player.class, level: player.level,
    xp: player.xp, statPoints, skillPoints, appearance, equipmentVisuals } as Helix2000Character;
  // Once a server has sent vitals, HP/MP are not in the key: the frame reads
  // them from the store (livePlayerVitals), whose hooks re-render only what
  // shows them. Until then they come from this object.
  const ownVitals = hasLiveVitals(player) ? null
    : [Math.round(player.health), player.maxHealth, Math.round(player.mana), player.maxMana];
  const key = JSON.stringify([player.id || player._id, snapshot.name, snapshot.class, snapshot.level,
    ownVitals, Math.round(snapshot.xp), statPoints, skillPoints, appearance, equipmentVisuals]);
  return { player: snapshot, renderKey: key };
}
